import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

// ADR 0006 §7: the post-login landing is the profile / community tier, a distinct tier from
// the workspace. This is the v1 placeholder -- deliberately no stats, Showcase, or API calls
// until the real design lands. The only job here is to be the thing users see first after
// sign-in, with a way through to the editor.
export function ProfilePlaceholder() {
  const { t } = useTranslation();
  return (
    <main className="profile-placeholder">
      <h1>{t('profilePlaceholder.heading')}</h1>
      <p>{t('profilePlaceholder.body')}</p>
      <Link className="profile-placeholder-cta" to="/draw">
        {t('profilePlaceholder.toEditor')}
      </Link>
    </main>
  );
}
